import { createReducer, getUpdater } from '@advanza/advanza_generic'
import { changeFilter, invalidateFilters, receiveList } from './sharedReducerHandlers'

const update = getUpdater()

const handlers = {
    LOGS_RECEIVE_LIST: receiveList,
    LOGS_CHANGE_FILTER: changeFilter,
    INVALIDATE_LOGS: invalidateFilters,
    LOGS_REQUEST: (state) =>
        update(state, {
            isFetching: { $set: true },
        }),
    RECEIVE_LOG_TYPES: (state, action) =>
        update(state, {
            logTypes: { $set: action.logTypes },
        }),
}

const initialState = {
    isFetching: false,
    didInvalidate: false,
    entities: {},
    result: {},
    counts: {},
    filters: {},
}

export default createReducer(initialState, handlers)
